module.exports = __webpack_public_path__ + "static/media/ic_dropdown_profile_attendance.c86ae1f9.svg";